import React, { useCallback, useLayoutEffect, useRef } from "react";

// Textarea, die zuverlässig mit dem Inhalt mitwächst (auch in Dialogen & auf iOS/Mobile).
// Startet mit minRows Mindesthöhe, wächst nach unten, kein internes Scrollen.
export default function AutoTextarea({ value, onChange, className = "", minRows = 2, ...rest }) {
  const ref = useRef(null);

  const resize = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const cs = window.getComputedStyle(el);
    const border =
      (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
    el.style.height = `${el.scrollHeight + border}px`;
  }, []);

  // Bei Wertänderung (inkl. Öffnen mit vorhandenem Inhalt) sofort anpassen.
  useLayoutEffect(() => { resize(); }, [value, resize]);

  // Nach Layout/Dialog-Animation & Fenstergröße erneut messen (wichtig für Mobile/Modals).
  useLayoutEffect(() => {
    const r1 = requestAnimationFrame(resize);
    const t = setTimeout(resize, 140);
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(r1);
      clearTimeout(t);
      window.removeEventListener("resize", resize);
    };
  }, [resize]);

  return (
    <textarea
      ref={ref}
      value={value || ""}
      rows={minRows}
      onChange={(e) => { onChange(e.target.value); resize(); }}
      className={"resize-none overflow-hidden " + className}
      {...rest}
    />
  );
}
